'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _Container = require('@/components/Container.vue');

var _Container2 = _interopRequireDefault(_Container);

var _ContainerHeader = require('@/customized-core/ContainerHeader.vue');

var _ContainerHeader2 = _interopRequireDefault(_ContainerHeader);

var _Sidebar = require('@/customized-core/Sidebar.vue');

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _MessageList = require('@/customized-core/MessageList.vue');

var _MessageList2 = _interopRequireDefault(_MessageList);

var _ServerView = require('@/customized-core/ServerView.vue');

var _ServerView2 = _interopRequireDefault(_ServerView);

var _Ad = require('@/customized-core/Ad.vue');

var _Ad2 = _interopRequireDefault(_Ad);

var _TypingUsersList = require('./TypingUsersList');

var _TypingUsersList2 = _interopRequireDefault(_TypingUsersList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mixins: [_Container2.default],
    components: {
        ContainerHeader: _ContainerHeader2.default,
        Sidebar: _Sidebar2.default,
        MessageList: _MessageList2.default,
        ServerView: _ServerView2.default,
        Ad: _Ad2.default,
        TypingUsersList: _TypingUsersList2.default
    },
    data: function data() {
        return {
            messageToProp: null,
            ml: null
        };
    },

    computed: {
        unreadMessages: function unreadMessages() {
            var count = 0;
            var highlight = false;
            _state2.default.networks.forEach(function (network) {
                network.buffers.forEach(function (buffer) {
                    if (buffer.isChannel() || buffer.isQuery()) {
                        count += buffer.flags.unread || 0;
                        if (buffer.flags.highlight) {
                            highlight = true;
                        }
                    }
                });
            });
            return { count: count, highlight: highlight };
        }
    },
    methods: {
        getML: function getML(ml) {
            this.ml = ml;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/Container.vue
// module id = bbe+
// module chunks = 1